module.exports = __webpack_public_path__ + "static/media/union_icon.f1072978.svg";